import React from "react";
import { DashboardCardProps } from "../../types/dashboard-card-props";
import ShuffleIcon from "@material-ui/icons/Shuffle";
import "./dashboard-card.component.scoped.scss";

export default function DashboardCard(props: DashboardCardProps) {
  const { title, total, icon, isDraggable, isDragging } = props;
  return (
    <div className={"dashboard-card " + (isDragging ? "dragging" : "") }>
      <div
        className="draggable-icon"
        style={{ visibility: isDraggable ? "visible" : "hidden" }}
      >
        <ShuffleIcon />
      </div>
      <div className="d-flex align-items-center p-relative">
        <div className="card-icon">
          <img src={icon} alt="" />
        </div>
        <div className="card-details">
          <div className="card-total trim">{total}</div>
          <div className="card-title trim">{title}</div>
        </div>
      </div>
    </div>
  );
}
